export default __webpack_public_path__ + "static/media/play_white.cb07fe2d.svg";